export default "__VITE_ASSET__06b96161__"